// extracted by mini-css-extract-plugin
export default {"container":"menuButton_container__-oAUD","icon":"menuButton_icon__YWBbr","link":"menuButton_link__0kfeC"};